module.exports = __webpack_public_path__ + "img/btn_删除.54686232.svg";